import React, { useEffect, useState } from 'react';

import {
    Button, Group, Stack, TextInput,
} from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { Link } from 'react-router-dom';

import { LIST_PAGE_URL, URL_TYPES } from './constants';
import { PUBLIC_DOMAIN } from '../../const';
import { apiFetcher } from '../../fetcher';
import PageFrame from '../../layouts/PageFrame';

function Canonical({
    history,
    match: { params: { id } },
}) {
    const [data, setData] = useState(null);
    const [urls, setUrls] = useState({
        old: '',
        new: '',
    });

    async function getCanonical() {
        const canonical = await apiFetcher(`v2/media.vkplay.ru/settings/redirects/${id}/`);

        setData(canonical);
    }

    async function setCanonical(newData) {
        const currentId = id ? `${id}/` : '';
        const method = id ? 'PUT' : 'POST';

        let canonical;

        try {
            canonical = await apiFetcher(`v2/media.vkplay.ru/settings/redirects/${currentId}`, {
                method,
                body: JSON.stringify(newData),
            });
        } catch (err) {
            notifications.show({
                title: 'Ошибка',
                message: err.message,
                color: 'red',
            });

            return;
        }

        notifications.show({
            title: 'Успешно сохранено',
            color: 'green',
        });

        history.push(LIST_PAGE_URL);
        setData(canonical);
    }

    function handleInput(e) {
        const { value, dataset } = e.currentTarget;
        const { type } = dataset;

        setUrls({
            ...urls,
            [type]: value,
        });
    }

    function constructUrl(dataAlias, dataSlug) {
        const type = dataAlias === 'news' ? 'news' : 'articles';
        const alias = dataAlias === 'news' ? '2024-01-01' : dataAlias;

        return `${PUBLIC_DOMAIN}/${type}/${alias}/${dataSlug}/`;
    }

    function deconstructUrl(constructedUrl) {
        const pathArray = constructedUrl.split('vkplay.ru/')?.[1]?.split('/');

        if (!pathArray?.length) {
            notifications.show({
                title: 'Что-то не так с URL',
                message: constructedUrl,
                color: 'red',
            });

            return;
        }

        const [pathType, pathAlias, pathSlug] = pathArray;

        const alias = pathType === 'news' ? 'news' : pathAlias;

        return {
            alias,
            slug: pathSlug,
        };
    }

    function serializeData(fetchedData) {
        return {
            old: constructUrl(fetchedData.alias_old, fetchedData.slug_old),
            new: constructUrl(fetchedData.alias_new, fetchedData.slug_new),
        };
    }

    function deserializeUrls(constructedUrls) {
        const { alias: oldAlias, slug: oldSlug } = deconstructUrl(constructedUrls.old);
        const { alias: newAlias, slug: newSlug } = deconstructUrl(constructedUrls.new);

        return {
            newAlias,
            oldAlias,
            newSlug,
            oldSlug,
        };
    }

    useEffect(() => {
        if (!id) {
            return;
        }

        getCanonical();
    }, [id]);

    useEffect(() => {
        if (!data) {
            return;
        }

        const constructedUrls = serializeData(data);

        setUrls(constructedUrls);
    }, [data]);

    function handleSave() {
        const {
            newAlias,
            oldAlias,
            newSlug,
            oldSlug,
        } = deserializeUrls(urls);

        setCanonical({
            alias_new: newAlias,
            alias_old: oldAlias,
            slug_new: newSlug,
            slug_old: oldSlug,
        });
    }

    return (
        <PageFrame type="canonical">
            <Stack
                maw={600}
                spacing="md"
            >
                {Object.keys(URL_TYPES).map((type) => (
                    <TextInput
                        key={type}
                        label={URL_TYPES[type]}
                        value={urls[type]}
                        onChange={handleInput}
                        data-type={type}
                    />
                ))}
                <Group mt="md">
                    <Button
                        variant="filled"
                        color="blue"
                        onClick={handleSave}
                    >
                        Сохранить
                    </Button>
                    <Button
                        variant="outline"
                        color="gray"
                        component={Link}
                        to={LIST_PAGE_URL}
                    >
                        Назад
                    </Button>
                </Group>
            </Stack>
        </PageFrame>
    );
}

export default Canonical;
